export const getAddressObject = (address_component) => {
    const ShouldBeComponent = {
        street_number: ["street_number"],
        postal_code: ["postal_code"],
        street: ["street_address", "route"],
        province: [
            "administrative_area_level_1",
            "administrative_area_level_2",
            "administrative_area_level_3",
            "administrative_area_level_4",
            "administrative_area_level_5",
        ],
        city: [
            "locality",
            "sublocality",
            "sublocality_level_1",
            "sublocality_level_2",
            "sublocality_level_3",
            "sublocality_level_4",
        ],
        country: ["country"],
    };

    let address = {
        street_number: "",
        postal_code: "",
        street: "",
        province: "",
        city: "",
        country: "",
    };

    address_component.forEach((component) => {
        for (var shouldBe in ShouldBeComponent) {
            if (
                ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1
            ) {
                if (shouldBe === "country") {
                    address[shouldBe] = component.short_name;
                } else {
                    address[shouldBe] = component.long_name;
                }
            }
        }
    });

    // Fix the shape to match our schema
    address.address = address.street_number + " " + address.street;
    delete address.street_number;
    delete address.street;
    if (address.country === "US") {
        address.state = address.province;
        delete address.province;
    }
    return address;
};

export const checkTodayTimeSlot = (delivery_pickup) => {
    const today = new Date();
    const dayName = today.getDay();
    const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
    let todayDay = days[dayName];
    let isSameDay = false;
    let selectedDeliveryPickupDay = delivery_pickup?.find((item) => {
        return item?.location?.location_online_order_settings?.some(
            (setting) => {
                return setting?.location_hrs_sub_slot?.some((slot) => {
                    if (slot?.day === todayDay) {
                        isSameDay = true;
                        return true;
                    }
                });
            }
        );
    });
    return isSameDay;
};
